import { PersonIdentifierViewModel } from '../../models/Entities/Person/Identifier/PersonIdentifierModels';
import { CommonState } from '../common/state/commonState';

export interface PersonIdentifierState extends CommonState<PersonIdentifierViewModel> {
    lastCreated?: PersonIdentifierViewModel;

    // identifier availability verification
    isVerifying: boolean;
    successVerifying: boolean | undefined;
    failOnVerifying: boolean;
    isIdentifierAvailable: boolean | undefined;
}

export const PersonIdentifierUnloadState: PersonIdentifierState = {
    isLoadingAll: false,
    successLoadingAll: undefined,
    failOnLoadingAll: false,

    isLoadingOne: false,
    successLoadingOne: undefined,
    failOnLoadingOne: false,

    isAddingNewOne: false,
    successAddingNewOne: undefined,
    failOnAddingNewOne: false,

    isUpdatingOne: false,
    successUpdatingOne: undefined,
    failOnUpdatingOne: false,

    isDeletingOne: false,
    successDeletingOne: undefined,
    failOnDeletingOne: false,

    isVerifying: false,
    successVerifying: undefined,
    failOnVerifying: false,
    isIdentifierAvailable: undefined,

    list: [],
    error: undefined,
    lastCreated: undefined
};
